import React, { Fragment, useEffect, useMemo, useState } from "react";
import { MapAdapter } from "../../../@tilannekuva/components/MapAdapter";
import { TMapAuditingCheck, TMapAuditingValue } from "../IMapAuditing";
import { MapAuditingMarker } from "./MapAuditingMarker";
import Control from 'react-leaflet-control';
import { Button } from "semantic-ui-react";
import { Viewport } from "react-leaflet";
import { parseMapLocation } from "../../../@tilannekuva/models/MapLocation";
import { LatLng } from "leaflet";
import "../MapAuditing.less";
import DraggableCircle from "../../../@leaflet/components/DraggableCircle";
import { IMap } from "../../../@tilannekuva/models/Map";


interface MapAuditingProps {
    map: IMap;
    formData: TMapAuditingValue | undefined;
    onAddNewCheck?: (center: [number, number]) => void;
    onSetCheck?: (key: string, checkData: TMapAuditingCheck) => void;
    onRemoveCheck?: (key: string) => void;
    titleType: "key" | "none";

    controls?: boolean;
    interactive?: boolean;
    style?: any
};

export const MapAuditing: React.FC<MapAuditingProps> = ({
    map,
    formData = {},
    onAddNewCheck,
    onSetCheck,
    onRemoveCheck,
    titleType,
    controls = true,
    interactive = true,
    style
}) => {

    const defaultPosition = map.defaultPosition; // `(tk=${map.id})(x=74.632)(y=-25.465)(z=4)`;
    const parsedPosition = parseMapLocation(defaultPosition)

    const [newMarkerCenter, setNewMarkerCenter] = useState<[number, number] | null>(null);
    const [viewport, setViewport] = useState<Viewport>({ center: parsedPosition?.center, zoom: parsedPosition?.zoom });

    const addNewMarker = () => setNewMarkerCenter(viewport?.center || null);
    const updateNewMarker = (center?: [number, number]) => center && setNewMarkerCenter(center);
    const clearNewMarker = () => setNewMarkerCenter(null);
    const acceptNewMarker = () => {
        if (onAddNewCheck && newMarkerCenter) {
            onAddNewCheck(newMarkerCenter);
            clearNewMarker();
        };
    };

    const handleViewPortChanged = (nextViewport: Viewport) => {
        if (nextViewport.center?.join("-") !== viewport.center?.join("-")) {
            setViewport(nextViewport);
            if (newMarkerCenter && nextViewport.center) {
                setNewMarkerCenter(nextViewport.center);
            };
        };
    };

    const renderCheckItem = (key: string, itemData?: TMapAuditingCheck) => (
        <Fragment key={key}>
            {itemData && (
                <MapAuditingMarker
                    title={titleType === "key" ? key : ""}
                    checkItem={itemData}
                    onChange={onSetCheck ? (checkData) => onSetCheck(key, checkData) : undefined}
                    onRemove={onRemoveCheck ? () => onRemoveCheck(key) : undefined}
                    interactive={!Boolean(newMarkerCenter)}
                />
            )}
        </Fragment>
    );

    const handleContainerClick = (event: any) => {
        console.info("handleContainerClick", event)
    }


    const layer = useMemo(() => (
        <Fragment>
            {Object.keys(formData).map((key) => renderCheckItem(key, formData[key]))}
        </Fragment>
    ), [formData, newMarkerCenter]);

    return (
        <div onClick={handleContainerClick}>

            <MapAdapter
                className="MapView-map MapAuditing"
                key={map.url}
                tilesetUrl={map.url}
                onViewportChanged={handleViewPortChanged}
                controls={controls}
                scrollWheelZoom={interactive}
                dragging={interactive}
                defaultPosition={map.defaultPosition}
                attribution={map.name}
                //  onclick={(event) => console.log(event.latlng)}
                style={style}
            >
                {newMarkerCenter && onAddNewCheck && (
                    <DraggableCircle
                        className="MapAuditing-new-marker"
                        onChange={updateNewMarker}
                        position={new LatLng(newMarkerCenter[0], newMarkerCenter[1])}
                        //@ts-ignore
                        center={newMarkerCenter}
                    />
                )}

                {onAddNewCheck && <Control
                    position="topright"
                    children={(
                        newMarkerCenter ? (
                            <Button.Group>
                                <Button content="Peru" size="tiny" onClick={clearNewMarker} />
                                <Button content="Hyväksy" size="tiny" onClick={acceptNewMarker} primary />
                            </Button.Group>
                        ) : <Button icon="marker" size="tiny" onClick={addNewMarker} />
                    )}
                />}
                {layer}
            </MapAdapter>

        </div >
    )
};
